import { GET_PURCHASES, PURCHASE_ERROR } from "../actions/types";

const initialState = {
  purchases: [],
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PURCHASES:
      return {
        ...state,
        purchases: payload,
        loading: false,
      };
    case PURCHASE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
